module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-parametric"
  }, [_c('div', {
    attrs: {
      "id": "download-protocol-pseudoform"
    }
  }, [_vm._l((_vm.protocolFields), function(param) {
    return (param.isFile) ? _c('div', [_c('label', [_vm._v(_vm._s(param.label))]), _vm._v(" "), _c('input', {
      attrs: {
        "name": param.name,
        "type": "file",
        "value": ""
      },
      on: {
        "change": function($event) {
          _vm.updateFile($event, param.name)
        }
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('form', {
    attrs: {
      "id": "download-protocol-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onDownload($event)
      }
    }
  }, [_vm._l((_vm.protocolFields), function(param) {
    return (!param.isFile) ? _c('div', [_c('label', [_vm._v("\n          " + _vm._s(param.label) + "\n        ")]), _vm._v(" "), (param.htmlElem === 'input' && !param.isFile) ? _c('input', {
      attrs: {
        "name": param.name,
        "type": param.type,
        "step": param.step
      },
      domProps: {
        "value": String(_vm.fieldValues[param.name])
      },
      on: {
        "input": function($event) {
          _vm.fieldValues[param.name] = param.castToNumber ? Number($event.currentTarget.value) : $event.currentTarget.value
        }
      }
    }) : _vm._e(), _vm._v(" "), (param.htmlElem === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.fieldValues[param.name]),
        expression: "fieldValues[param.name]"
      }],
      attrs: {
        "name": param.name
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.fieldValues, param.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((param.options), function(opt) {
      return _c('option', {
        domProps: {
          "value": opt.value,
          "selected": opt.value === opt.default
        }
      }, [_vm._v(_vm._s(opt.label))])
    })) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "id": "download-protocol",
      "data-gtm-action": _vm.subdomain,
      "data-gtm-category": "Protocol-Download",
      "data-gtm-label": _vm.protocolSlug
    },
    domProps: {
      "value": 'Download For ' + _vm.robotTab
    }
  })], 2)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b77b722!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ParameterizeAndDownload.vue
// module id = 232
// module chunks = 2